import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isArray } from 'lodash';
import Avatar from '../component/Avatar/Avatar';
import LayoutLoader from '../component/LayoutLoader/LayoutLoader';
import { minSearchQueryLength } from 'config';

/**
 * Search box
 * @prop defaultValue default value in search box
 * @prop placeholder input placeholder
 * @prop keyUpTimeout delay interval for emit onSearchAction
 * @prop onSearchAction search input action callback
 */
exports.Searchbox = React.createClass({

  internalTimer: null,

  propTypes: {
    className: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    keyUpTimeout: PropTypes.number,
    minQueryLength: PropTypes.number,
    onSearchAction: PropTypes.func,
    wrapControl: PropTypes.bool,
    maxSearchLength: PropTypes.number,
    dropValue: PropTypes.bool,
    children: PropTypes.any,
  },

  getDefaultProps(){
    return {
      value: "",
      placeholder: null,
      keyUpTimeout: 800,
      minQueryLength: minSearchQueryLength,
      wrapControl: true,
      maxSearchLength: 100,
      dropValue: false
    }
  },

  getInitialState(){
    var {value} = this.props;
    return {
      value: value
    }
  },

  componentWillReceiveProps(nextProps){
    if (nextProps.dropValue) {
      this.setState({value: nextProps.value});
    }
  },

  render(){
    var { placeholder, children, className, wrapControl } = this.props;
    placeholder = placeholder || i18n.t("Search", {context: 'UI', ns: 'main'});

    var control = (
      <div className={classNames('input-group', !wrapControl && className)}>
        <span className="input-group-addon"><i
          className="fa fa-search"></i></span>
        <input
          className="form-control"
          placeholder={placeholder}
          type="text"
          value={this.state.value}
          onChange={this._onChange}
          ref="SearchInputField"
        />
        {children}
      </div>
    );

    return wrapControl
      ? (<div className={classNames('widget-body-toolbar', className)}>{control}</div>)
      : control;
  },

  _onChange(){
    var currentValue = this._getCurrentValue();

    if (currentValue.length > this.props.maxSearchLength) {
      return;
    } else {
      this.setState({value: currentValue});
    }

    if (!this.props.onSearchAction) return;

    if (currentValue.length > 0 && currentValue.length < this.props.minQueryLength) {
      return;
    }

    clearTimeout(this.internalTimer);
    this.internalTimer = setTimeout(this._emitChangeEvent, this.props.keyUpTimeout);
  },

  _emitChangeEvent(){
    var currentValue = this._getCurrentValue();
    this.props.onSearchAction(currentValue);
  },

  _getCurrentValue(){
    return this.refs.SearchInputField.value;
  }

});

/**
 * layout loader
 * @deprecated
 */
exports.LayoutLoader = LayoutLoader;

/** App absolute popover*/
exports.AppPopover = React.createClass({

  propTypes: {
    x: React.PropTypes.number.isRequired,
    y: React.PropTypes.number.isRequired,
    title: React.PropTypes.node,
    position: React.PropTypes.string,
    width: React.PropTypes.number,
    height: React.PropTypes.number
  },

  getDefaultProps(){
    return {
      position: 'top',
      width: 220,
      height: 150
    }
  },

  render(){
    var {position, x, y, className} = this.props;
    var style = this._getStyle();

    var classname = {
      "popover": true
    };
    classname[position] = true;
    if (className) {
      classname[className] = true;
    }

    return (
      <div className={classnames(classname)} style={style}>
        <div className="arrow"></div>
        {this._getTitle()}
        <div className="popover-content">
          {this.props.children}
        </div>
      </div>
    );
  },

  _getTitle(){
    var {title} = this.props;
    return title !== null
      ? (<h3 className="popover-title">{title}</h3>)
      : null;
  },

  _getStyle(){
    var {position, x, y, width, height} = this.props;

    y = y + window.pageYOffset;
    x = x + window.pageXOffset;

    switch (position) {
      case 'top':
        return {
          top: y - (height + 5),
          left: x - (width / 2),
          right: 'auto',
          display: "block",
          width: width + "px",
          height: height + "px",
          zIndex: 1050
        };
      case 'left':
        return {
          top: y - (height / 2 + 5),
          left: x - (width - 5),
          right: 'auto',
          display: "block",
          width: width + "px",
          height: height + "px",
          zIndex: 1050
        };
      case 'bottom':
        return {
          top: y,
          left: x - 110,
          right: 'auto',
          display: "block",
          width: width + "px",
          height: height + "px",
          zIndex: 1050
        };
      case 'right':
        return {
          top: y - (height / 2 + 5),
          left: x + 5,
          right: 'auto',
          display: "block",
          width: width + "px",
          height: height + "px",
          zIndex: 1050
        };
    }

    return {left: x, top: y, display: "block"}
  }

});

/**
 * error message control
 */
exports.ErrorMessage = React.createClass({
  propTypes: {
    errorMessage: React.PropTypes.oneOfType([
      React.PropTypes.node,
      React.PropTypes.array
    ])
  },

  getDefaultProps(){
    return {
      errorMessage: null
    };
  },

  render(){
    var {errorMessage} = this.props;
    if (!errorMessage) return null;

    if (!isArray(errorMessage)) {
      errorMessage = [errorMessage];
    }

    return (
      <div>
      {errorMessage.map(this._getErrorItem)}
      </div>
    );
  },

  _getErrorItem(errorMessage, index){

    return (
      <div key={index} className="esk-error-message alert alert-danger fade in">
        <span>{errorMessage}</span>
      </div>
    )
  }
});

export const WarningMessage = ({ children }) => (
  <div className="esk-warning-message alert alert-warning">{children}</div>
);
WarningMessage.propTypes = { children: PropTypes.string };

exports.ProgressBar = React.createClass({

  propTypes: {
    percent: React.PropTypes.number,
    color: React.PropTypes.string,
    type: React.PropTypes.string
  },

  getDefaultProps(){
    return {
      percent: 0,
      color: "bg-color-blue",
      type: ""
    }
  },

  getInitialState(){
    var {percent} = this.props;

    return {
      percent: percent
    }
  },

  componentWillReceiveProps(nextProps){
    if (nextProps.percent != this.state.percent) {
      this.setState({percent: nextProps.percent});
    }
  },

  render(){
    var {percent} = this.state;
    var {color, type} = this.props;
    var barClassName = "progress-bar " + color;
    var barTypeClassName = "progress left " + type;
    return (
      <div className={barTypeClassName}>
        <div className={barClassName}
             style={{width: percent + "%"}}>{percent}%
        </div>
      </div>
    );
  }
});

exports.DropZone = React.createClass({

  propTypes: {
    message: React.PropTypes.node,
    onDrop: React.PropTypes.func,
    multiple: React.PropTypes.bool,
    accept: React.PropTypes.string
  },

  getDefaultProps(){
    return {
      message: null,
      multiple: true
    }
  },

  openFileDialog(){
    this.refs.dropzone.open();
  },

  render(){
    var {onDrop, multiple, accept} = this.props;

    return (
      <ReactDropzone
        ref="dropzone"
        multiple={multiple}
        onDrop={onDrop}
        className="dropzone dz-clickable"
        disableClick={true}
        accept={accept}
      >
        {this.getContent()}
      </ReactDropzone>
    )
  },

  getContent(){
    if (this.props.children) {
      return this.props.children;
    }

    return (
      <div className="dz-default dz-message">
            <span>
                <span className="text-center">
                {this.props.message || this._getDefaultMessage()}
                </span>
            </span>
      </div>
    )
  },

  _getDefaultMessage(){
    return (
      <span>
                <span className="font-lg">
                    <i
                      className="fa fa-caret-right text-danger"></i>{i18n.t("Drop files to upload", {
                  context: 'UI',
                  ns: 'main'
                })}
                </span>
            </span>
    );
  }
});

// @deprecated
exports.AvatarField = Avatar;


